(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["getout-display-qr"]) return;
  try {
    
if (!customElements.get('getout-display-video')) {
  customElements.define('getout-display-video', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const initialize = () => {
        const video = this.querySelector('video');
        const sound = this.querySelector('.qr-sound');
        const play = this.querySelector('.qr-play');
        const error = this.querySelector('.qr-error');
        if (!video || !sound || !play || !error) return false;
        this.observer?.disconnect();
        let started = false;
        let userInteracted = false;
        let attempting = false;
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        const sync = () => {
          sound.textContent = video.muted ? this.dataset.soundOn : this.dataset.soundOff;
          sound.setAttribute('aria-pressed', String(!video.muted));
          play.hidden = Boolean(video.error) || (started && !video.paused);
        };
        const showError = () => {
          error.hidden = false;
          sound.hidden = true;
          play.hidden = true;
        };
        const autoStart = () => {
          if (started || userInteracted || attempting || video.error || document.hidden) return;
          attempting = true;
          video.play().then(() => { started = true; sync(); }).catch(() => {
            if (!video.error) play.hidden = false;
          }).finally(() => { attempting = false; });
        };
        sound.hidden = false;
        play.hidden = false;
        sound.addEventListener('click', () => {
          userInteracted = true;
          video.muted = !video.muted;
          if (video.paused) video.play().then(() => { started = true; sync(); }).catch(sync);
          sync();
        }, options);
        play.addEventListener('click', () => {
          userInteracted = true;
          video.play().then(() => { started = true; sync(); }).catch(sync);
        }, options);
        video.addEventListener('playing', () => {
          started = true;
          error.hidden = true;
          sync();
        }, options);
        for (const event of ['pause', 'ended', 'volumechange']) {
          video.addEventListener(event, sync, options);
        }
        for (const event of ['loadedmetadata', 'loadeddata', 'canplay']) {
          video.addEventListener(event, autoStart, options);
        }
        document.addEventListener('visibilitychange', autoStart, options);
        window.addEventListener('pageshow', autoStart, options);
        video.addEventListener('error', showError, options);
        if (video.error) showError();
        else autoStart();
        return true;
      };
      if (!initialize()) {
        this.observer = new MutationObserver(() => initialize());
        this.observer.observe(this, { childList: true, subtree: true });
      }
    }
    cleanup() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
    disconnectedCallback() { this.cleanup(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
